module.exports = __webpack_public_path__ + "img/labelsNumbersOrderOn.9d5dad5f.svg";